import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '@noom/wax-component-library';
import SideMenu from '../../../core/components/SideMenu';
import SideSectionCommunity from '../../../social/components/SideSectionCommunity';
import SideSectionMyCommunity from '../../../social/components/SideSectionMyCommunity';
import UiKitSocialSearch from '../../../social/components/SocialSearch';
import { useConfig } from '../../../social/providers/ConfigProvider';
const SocialSearch = styled(UiKitSocialSearch) `
  padding: 0.5rem 0;
`;
const CommunitySideMenu = ({ className, activeCommunity, activePage, communityListProps }) => {
    const { showCreatePublicCommunityOption } = useConfig();
    return (React.createElement(SideMenu, { className: className, "data-qa-anchor": "community-side-menu" },
        React.createElement(SocialSearch, { sticky: true }),
        React.createElement(SideSectionCommunity, { activePage: activePage }),
        React.createElement(Box, { flex: 1, minH: 0 },
            React.createElement(SideSectionMyCommunity, { activeCommunity: activeCommunity, communityListProps: communityListProps, canCreatePublicCommunity: showCreatePublicCommunityOption }))));
};
CommunitySideMenu.propTypes = {
    className: PropTypes.string,
    activeCommunity: PropTypes.string,
};
export default CommunitySideMenu;
//# sourceMappingURL=CommunitySideMenu.js.map